<template>
  <div id="verify_email_page_wrap">
    <div id="verify_email_page">
      <a :href="site_url" class="logo_mobile" id="logo"></a>

      <div v-if="status === 'loading'" class="verify_state">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        <p>מאמתים את כתובת המייל...</p>
      </div>

      <div v-else-if="status === 'success'" class="verify_state">
        <h2>המייל אומת בהצלחה</h2>
        <p v-if="alreadyVerified">החשבון שלך כבר היה מאומת. אפשר להתחבר.</p>
        <p v-else>כעת אפשר להתחבר לחשבון עם הסיסמה שבחרתם.</p>
        <a class="btn" @click="goto('/login')">מעבר להתחברות</a>
      </div>

      <div v-else class="verify_state">
        <h2>אימות המייל נכשל</h2>
        <p>{{ errorMsg }}</p>
        <a class="btn" @click="goto('/login')">חזרה להתחברות</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: 'loading',
      errorMsg: 'קישור לא תקין או פג תוקף',
      alreadyVerified: false,
    };
  },
  mounted() {
    const uid = this.$route.query.uid;
    const code = this.$route.query.code;

    if (this.isNull(uid) || this.isNull(code)) {
      this.status = 'error';
      return;
    }

    this.api({ action: 'verify_email', data: { uid, code } }, (res) => {
      if (res.data && res.data.success) {
        this.status = 'success';
        this.alreadyVerified = !!res.data.already_verified;
      } else {
        this.status = 'error';
        if (res.data && res.data.error) this.errorMsg = res.data.error;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
#verify_email_page_wrap { min-height: 100vh; display: flex; align-items: center; }
#verify_email_page { width: 400px; max-width: 80%; margin: 0 auto; text-align: center; }
#logo { mask: url(../assets/logo.svg); display: block; height: 120px; background: #000; mask-size: contain; mask-repeat: no-repeat; mask-position: center; margin-bottom: 25px; }
.verify_state {
  h2 { font-size: 24px; margin-bottom: 12px; }
  p { color: #666; margin-bottom: 20px; line-height: 1.5; }
  .btn { cursor: pointer; display: inline-block; background: #ff1661; color: #fff; padding: 12px 40px; border-radius: 45px; font-weight: 600; height: auto; }
}
</style>
